import React from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router-dom'
import ErrorBoundary from 'components/ErrorBoundary'
import SitesSearch from '../SitesSearch'
import Site from '../Site'

const SitesManager: React.FC<RouteComponentProps> = ({ match }) => {
  return (
    <ErrorBoundary>
      <Switch>
        <Route path={`${match.path}/:id`} render={() => <Site />} />
        <Route path={match.path} render={() => <SitesSearch />} />
      </Switch>
    </ErrorBoundary>
  )
}

export default SitesManager
